import { baseTheme } from '@src/theme';
import { Dropdown, Space } from 'antd';
import { styled } from 'styled-components';

export const StyledDropButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const StyledDropdown = styled(Dropdown)`
    .ant-dropdown-menu {
        background-color: ${(props) =>
            props.theme?.colors?.secondary?.light?.contentBg ||
            baseTheme.colors.secondary.light.contentBg};
        border: 1px solid
            ${(props) =>
                props.theme?.colors?.secondary?.light?.divider ||
                baseTheme.colors.secondary.light.divider};
        box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08);
        border-radius: 8px;

        .ant-dropdown-menu-item {
            color: ${(props) =>
                props.theme?.colors?.secondary?.main?.text ||
                baseTheme.colors.secondary.main.text};

            &:hover {
                background-color: ${(props) =>
                    props.theme?.colors?.secondary?.light?.surfaceHover ||
                    baseTheme.colors.secondary.light.surfaceHover};
            }

            &.ant-dropdown-menu-item-selected {
                background-color: ${(props) =>
                    props.theme?.colors?.primary?.light?.filled ||
                    baseTheme.colors.primary.light.filled};
                color: ${(props) =>
                    props.theme?.colors?.primary?.light?.text ||
                    baseTheme.colors.primary.light.text};

                &:hover {
                    background-color: ${(props) =>
                        props.theme?.colors?.primary?.light?.hover ||
                        baseTheme.colors.primary.light.hover};
                }
            }

            &.ant-dropdown-menu-item-disabled {
                color: ${(props) =>
                    props.theme?.colors?.secondary?.light?.text ||
                    baseTheme.colors.secondary.light.text};
            }
        }
    }
`;

export const StyledButtonContent = styled(Space)`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: 4px;
`;

export const StyledContentLeft = styled(Space)`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
`;

export const StyledMenuItem = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    .menu-item-content {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 16px;
    }

    .menu-item-description {
        font-size: 12px;
        color: ${(props) =>
            props.theme?.colors?.secondary?.light?.text ||
            baseTheme.colors.secondary.light.text};
    }
`;

export const StyledErrorMessage = styled.div`
    margin-top: 4px;
    color: ${(props) =>
        props.theme?.colors?.error?.main?.text ||
        baseTheme.colors.error.main.text};
`;
